<template>
  <div class="main-content ">
    
    <!-- 轮播图区域 -->
    <div id="home-banner">
		
      <div class="bannder">
        <el-carousel height="450px" arrow="never" :interval="90000" >
          <el-carousel-item v-for="(item,index) in banner" :key="index" >
            <img :src="item.img" alt="" @click="bannerJump(item)">
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="banner-content hnw-area-center">
        
        <!-- <div class="goods-classify">
          <el-collapse v-model="activeClassifys" accordion>
            <el-collapse-item title="" name="1">
              <template slot="title">
                <div class="classifys-head">
                  <img src="../../assets/newHome/分类.png" alt="" srcset="">
                  产品分类
                </div>
              </template>
              <div class="classifys-list" name="1">
                <div 
                  class="classifys-item"  
                  v-for="(item,index) in classifys" 
                  :key="index"
                  @mouseover="item.showNames=true"
                  @mouseleave="item.showNames=false"
                >
                  <div class="classifys-title">
                    <div class="title-left">
                      <img  :src="require(`../../assets/newHome/classifys/${item.img}.png`)"  alt="" srcset="">
                      
                      
                      {{ item.oert }}
                    </div>
                    <div class="title-r">
                      <img class="more"  src="../../assets/newHome/更多1.png" alt="" srcset="">
                      

                    </div>
                  </div>
                  <div class="goods-name" @click="findGoods('searchText',item.oert)">
                    <span class="name" v-for="(name,index1) in item.names" :key="index1">
                      {{ name }}
                    </span>
                  </div>

                  <div class="more-names" v-if="item.showNames">
                    <span class="name" v-for="(name,index1) in item.names" :key="index1" @click="findGoods('searchText',name)">
                      {{ name }}
                    </span>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          
          
        </div> -->
        <div>

        </div>
        <div class="user-info" :class="{'hide-user-info':!activeMyInfo}">
          <div class="user-head">
            <img  :src="$store.state.member_avatar||require('../../assets/newHome1/tx.png')" alt="" class="logo-face">
            <div class="huanying" @click="activeMyInfo=!activeMyInfo">
              欢迎来到华诺威!
              <i v-show="!activeMyInfo" class="el-icon-arrow-right"></i>
              <i v-show="activeMyInfo"  class="el-icon-arrow-down"></i>
            </div>
            <div class="store-name" v-if="$store.state.member_id">
              {{ $store.state.member_name }}
            </div>
            <div class="user-btn" v-else>
              <el-button @click="toPath('/Register')">注册</el-button>
              <el-button class="lo-gin" @click="toPath('/login')" >登录</el-button>
            </div>
          </div>
          <div class="menu-box" v-show="activeMyInfo"> 
            <div class="menu-list">
              <div 
                class="menu-item"
                v-for="(menu, index) in homeMenuList"
                :key="index"
                @click="toPath(menu.path)"
              >
                <img
                style="width: 16px; height: 16px; padding-right: 5px"
                :src="menu.image"
                alt=""
                />
                <div class="menu-title">
                  {{ menu.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w">
      <!-- 快捷功能区域 -->
      <div class="quick-actions">
        <div 
          v-for="(action, index) in quickActions" 
          :key="index"
          class="action-item" 
          :class="[
            action.title === '新产品' ? 'new-products' : '',
            action.title === '我的报表' ? 'my-reports' : '',
            action.title === '最近资讯' ? 'recent-orders' : ''
          ]"
          @click="handleQuickActionClick(action)"
        >
          <img class="back-img" :src="action.image"/>
          <div class="icon">
          </div>
          <div class="text" v-if="action.title !== '奔宝专区'">
            <p class="title">{{ action.newTitle || action.title }}
              <span class="title-date" v-if="action.title === '我的报表'&&$store.state.store_id!=1780">(日期: 近365天)</span>
              <img v-if="action.ricon" :src="action.ricon"  class="title-icon" />
            </p>

            <div class="text-content">
              <div v-if="action.isHnw" class="hnw-btns">
                <div class="hnw-btn" @click.stop="toPath('/reportCenter/index/newSaleAnalysis')">
                  <img src="../../assets/newHome1/xsfx.png" alt="" srcset="">
                </div>
                <div class="hnw-btn" @click.stop="toPath('/reportCenter/index/inveStatis')">
                  <img  src="../../assets/newHome1/kcfx.png" alt="" srcset="">
                </div>
                
              </div>
              <div v-else-if="action.tags" class="tags">
                <span v-for="(tag, tagIndex) in action.tags" :key="tagIndex" class="tag">{{ tag }}</span>
              </div>

              <div class="sku" v-loading="repoLoding" v-else-if="Array.isArray(action.description)" v-for="(desc, descIndex) in action.description" :key="descIndex">
                <div class="dot"></div>
                <span>{{ desc }}</span>
              </div>
              
              <p v-else >{{ action.description }}</p>
              <div class="dh-sku" v-if="action.dhSku">
                <div class="label">
                  今日到货：
                  
                </div>
                 <div class="num">
                   {{ action.dhSku }}
                 </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- 推荐banner区域 -->
      <!-- <h3>热门商品</h3> -->
      <div class="hot-products">
        <div class="title-section">
          <div class="category-tags">
            <div 
              class="tag" 
              v-for="tag in hotProducts" 
              :key="tag.data" 
              :class="{ active: tag.data === selectedTag }"
              @click="bannerJump(tag)"
            >
              {{ tag.data }}
            </div>
          </div>
          
        </div>
        <div class="products-grid">
          <el-row :gutter="10">
            <el-col :span="6" v-for="item in hotProducts"  :key="item.goods_id" class="product-col">
              <div class="product-card">
               <img :src="item.image" class="product-image" @click="bannerJump(item)" alt="" srcset="">
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

       <!-- 常用功能区域 -->
      <div class="common-functions">
        <h3 class="section-title">常用功能</h3>
        <div class="functions-grid">
          
  
          <div class="feature-item" v-for="(func, index) in commonFunctions" :key="index"  @click="toPath(func.path)" :style="{ backgroundColor: func.backgroundColor }">
           
            <!-- <div class="text-section">
              <h3 class="title" :style="{ color: func.textColor, fontSize: '28px' }">{{ func.title }}</h3>
              <button
                class="custom-action-btn"
                @click="toPath(func.path)"
                :style="{ backgroundColor: func.textColor }"
              >
                {{ func.description }}
              </button>
            </div> -->
  
            <!-- 右侧：图片 -->
            <img :src="func.image" alt="icon" class="icon-img" />
          </div>
        </div>
      </div>

      <!-- 自主品牌区域 -->
      <div class="brand-section">
        <h3 class="section-title">自主品牌</h3>
        <div class="brands-grid">
          <el-row :gutter="20">
            <el-col :span="12" v-for="(brand, index) in homeBrandList" :key="index" class="brand-column" :id="brand.title">
              <div class="brand-card" style="display: flex;">
                <div class="brand-left" style="width: 148px; height: 332px;">
                  <img :src="require(`../../assets/newHome1/首页品牌${brand.title}.png`)" alt="Brand Logo" @click="comSearchBrand(brand.title)" style="width: 148px; height: 332px; object-fit: cover;" />
                </div>
                <div class="brand-products" style="flex: 1; padding: 15px;">
                  <!-- 上面三个商品 -->
                  <div class="top-three-products">
                    <div 
                      v-for="(product, idx) in homeBrandGoodsList[brand.title].slice(0, 3)" 
                      :key="idx" 
                      class="brand-product"
                      @click="toGoodsInfo(product)"
                    >
                      <div class="product-details">
                        <p>{{ product.goods_name }}</p>
                        <p class="oe">OE号：{{ product.oecode }}</p>
                        <p class="price">¥ {{ product.goods_price }}</p>
                      </div>
                      
                      <HnwOssImg :src="product.homeImg" :width="98"></HnwOssImg>
                    </div>
                  </div>
                  <!-- 下面两个商品 -->
                  <div class="bottom-two-products">
                    <div 
                      v-for="(product, idx) in homeBrandGoodsList[brand.title].slice(3, 5)" 
                      :key="idx + 3" 
                      class="brand-product horizontal-layout"
                      @click="toGoodsInfo(product)"
                    >
                      <HnwOssImg :src="product.homeImg" :width="60" class="product-image-left"></HnwOssImg>
                      <div class="product-details-horizontal">
                        <p>{{ product.goods_name }}</p>
                        <p class="oe">OE号：{{ product.oecode }}</p>
                        <p class="price">¥ {{ product.goods_price }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
  
     
  
      <!-- 猜你喜欢区域 -->
      <div class="recommended-section">
        <h3 class="section-title">猜你喜欢</h3>
        <div class="recommended-grid">
          <!-- 新增的商品轮播展示区 -->
          <div class="left-product-carousel" >
            <swiper
              :options="leftSwiperOptions"
              ref="leftSwiper"
              class="left-custom-swiper"
            >
              <!-- 轮播项 -->
              <swiper-slide v-for="(item, index) in recommended.slice(0, 3)" :key="index">
                <div class="left-product-card">
                  <div class="left-product-item">
                    <!-- 商品图片 -->
                    <HnwOssImg :src="item.homeImg" :width="170"></HnwOssImg>
                    <!-- 商品信息 -->
                    <div class="left-product-info">
                      <h3 class="title">{{ item.goods_name }}</h3>
                      <p class="oe">OE号：{{ item.oecode }}</p>
                      <p class="price">¥ {{ item.goods_price }}</p>
                    </div>

                  </div>
                </div>
              </swiper-slide>
              
              <!-- 分页器 -->
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          
          <!-- 原有的推荐商品网格 -->
          <div class="right-recommend-grid">
            <el-row :gutter="20">
              <el-col :span="6" v-for="item in recommended.slice(0, 4)" :key="item.id" class="recommend-col">
                <div  class="goods-card"   @click="toGoodsInfo(item)">
                  <div class="img-box" >
                    <HnwOssImg  :src="item.homeImg" :width="180"></HnwOssImg>
                  </div>
                  
                  <div class="card-fot">
                    <div class="goods-name">{{item.goods_name}}</div>
                    <div class="goods-msg">品牌: {{item.oenaturebrand}}</div>
                    <div class="goods-msg">适配车型: {{item.vehicletype}}</div>
                    <div class="goods-msg">OE号: {{item.oecode}}</div>
                    <div v-if="!$store.getters.isVisitor" class="join-cart-box" @click.stop="joinCart(item)">
                      <img src="../../assets/newHome/购物车.png" alt="" srcset="">
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  // 引入 Swiper 组件和样式
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

  
export default {
  name: 'MainContent',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      // 轮播图数据
      banner: [],
      
      // 左侧轮播配置
      leftSwiperOptions: {
        loop: true, // 循环播放
        // 自动播放

        autoplay: {
          delay: 3000,
          disableOnInteraction: true // 手动滑动后继续自动播放
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 圆点可点击
        },
        spaceBetween: 20,
        slidesPerView: 1,
        effect: 'slide'
      },
      // 左侧轮播数据
      leftCarouselItems: [],
      
      // 产品分类数据
      classifys: [
        {
          oert: "车身系统",
          img: "cheshen",
          showNames: false,
          names: []
        },
        { 
          oert: "发动机系统",
          img: "fadongji",
          showNames: false,
          names: []
        },
        {
          oert: "底盘悬挂系统",
          img: "dipan",
          showNames: false,
          names: []
        },
        {
          oert: "电子电器系统",
          img: "dianzidq",
          showNames: false,
          names: []
        }
      ],
    
      // 分类图片列表
      
      activeClassifys: "",
      
      // 用户信息
      activeMyInfo: false,
      
      // 快捷功能数据
      quickActions: [
        {
          icon: 'el-icon-shopping-cart-full',
          title: '新产品',
          image: require('@/assets/newHome1/新产品.png'),
          tags: [],
          backgroundImage: 'linear-gradient(to right, #00a651, #007d3d)'
        },
        
        // {
        //   icon: 'el-icon-shopping-cart-full',
        //   title: '奔宝专区',
        //   image: require('@/assets/newHome1/benbaozhuanqu.png'),
        //   tags: [],
        //   backgroundImage: 'linear-gradient(to right, #00a651, #007d3d)'
        // },
        {
          icon: 'el-icon-data-analysis',
          title: '我的报表',
          image: require('@/assets/newHome1/我的报表.png'),
          description: [],
          isHnw: this.$store.state.store_id==1780,
          backgroundImage: 'linear-gradient(to right, #00a651, #007d3d)'
        },
        {
          icon: 'el-icon-document',
          title: '最近资讯',
          image: require('@/assets/newHome1/最近咨询.png'),
          ricon: require('@/assets/newHome1/trhot.png'),
          description: '',
          backgroundImage: 'linear-gradient(to right, #ff9800, #e67e22)'
        },
        // {
        //   icon: 'el-icon-document',
        //   title: '今日到货',
        //   image: require('@/assets/newHome1/今日到货.png'),
        //   // ricon: require('@/assets/newHome1/trhot.png'),
        //   description: '',
        //   dhSku:"",
        //   backgroundImage: 'linear-gradient(to right, #ff9800, #e67e22)'
        // }
      ],
      
      // 热门商品数据
      hotProducts: [],
      
      selectedTag: '', // 当前选中的标签
      
      // 品牌数据
      brands: [],
      
      // 常用功能数据
      commonFunctions: [
        {
          icon: 'el-icon-shopping-cart-full',
          title: '积分商城',
          image: require('@/assets/newHome1/积分商城.png'),
          description: '点击兑换>',
          backgroundColor: '#fffbe6',
          textColor: '#7A4F4F',
          path: '/integral'
        },
        {
          icon: 'el-icon-data-analysis',
          title: '报表中心',
          image: require('@/assets/newHome1/报表.png'),
          description: '点击查看>',
          backgroundColor: '#e6f5ff',
          textColor: '#3A5B86',
          path: '/reportCenter/index/inveStatis'
        },
        {
          icon: 'el-icon-present',
          title: '促销专区',
         
          image: require('@/assets/newHome1/促销.png'),
          description: '立即抢购>',
          backgroundColor: '#fff6e6',
          textColor: '#B12C14',
          path: '/index/disgoods/1/all/71'
        }
      ],
      
      // 推荐商品数据
      recommended: [],
      
      // 秒杀商品数据
      seckiList: [],
      splist: ['时', '分', '秒'],
      
      // 其他图片列表
      homeImgList: [],
      
      // 导航相关
      navLeft: 0,
      navObj: {},
      scrollDistance: 0,
      
      // 品牌列表
      homeBrandList: [],
      homeBrandGoodsList: {},
      
      // 品牌颜色配置
      brandColors: [
        '#2260BB',
        '#FF6B35',
        '#00A651',
        '#6A5ACD',
        '#FF4500',
        '#20B2AA'
      ],
      repoLoding:false,
      // 菜单列表
      homeMenuList: [
        {
          title: "我的订单",
          image: require('@/assets/newHome1/订单.png'),
          path: "/my/order"
        },
        {
          title: "账号信息",
          image: require('@/assets/newHome1/账号.png'),
          path: "/my/account/0"
        },
        {
          title: "企业信息",
          image: require('@/assets/newHome1/企业.png'),
          path: "/my/company"
        },
        {
          title: "我的地址",
          image: require('@/assets/newHome1/地址.png'),
          path: "/my/address"
        }
      ]
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.getQuickActions();
      // 获取轮播图数据
      await this.getBanner();
      // 获取快捷功能
      // 获取热门banner数据
      await this.getHotBanner();
      
      // 获取左侧轮播商品数据
      this.getLeftCarouselItems();
      
      // 获取品牌列表和商品
      this.$nextTick(() => {
        this.getBrandList();
        this.getRecommendGoodsList();
      });
      
      // 获取分类名称
      this.classifys.forEach(async item => {
        let res = await this.$api.getGoosNamesByOesort(item.oert);
        item.names = res;
      });
      
      // 获取秒杀商品
      this.getSeckillList();
      
      // 获取热门商品数据
      // this.getHotProducts();
      
    },
    
    async getQuickActions() {
      try {
        // 获取新产品月份标签数据
        const monthRes = await this.$api.getDisList({
          type: 12,
          page: 1,
          limit: 6
        });
        
       
        
        // 获取新闻列表数据
        const newsRes = await this.$api.getNewsList({
          page: 1,
          limit: 999
        });
        
        
        // 处理新产品月份标签数据
        // 提取前6个月份的标题作为标签
        if (monthRes && monthRes.length > 0) {
          const tags = monthRes.slice(0, 6).map(month => month.title + '月');
          this.quickActions[0].tags = tags;
        }
        // console.log("tags",tags);
        // 处理新闻数据
        if (newsRes && newsRes.db && newsRes.db.length > 0) {
          // 取is_push=1的 一条新闻，找不到再用最新的
          const latestNews = newsRes.db.find(news => news.is_push == 1) || newsRes.db[0];
          // const latestNews = newsRes.db[0];
          
          
          this.quickActions[2].newTitle = latestNews.category;
          this.quickActions[2].description = latestNews.subtitle;
          this.quickActions[2].newsId = latestNews.id;
        }
        // 今日到货
        // try {
        //   let dhRes = await this.$api.getArrivedTodaySearch({
        //     store_curpage:1,
        //     store_page: 1,
        //     store_id: this.$store.state.store_id,
        //     code: this.$store.state.is_sh=='0' ? '丹阳仓' : '上海仓',
        //   });
        //   this.quickActions[3].dhSku =  dhRes.data[0].total;
        // } catch (error) {
        //   console.error('获取今日到货数据失败:', error);
        //   this.quickActions[3].dhSku =  0;
        // }
        
        
        
        this.repoLoding = true
        // 获取报表数据 较慢
        if(this.$store.state.store_id!=1780){
          
          const reportRes = await this.$api.getReportListNew({
            buyer_id: this.$store.state.store_id,
            start: Math.floor((Date.now() - 365 * 24 * 60 * 60 * 1000) / 1000), // 365天前
            end: Math.floor(Date.now() / 1000), // 当前时间
            page: 1,
            limit: 1000
          });
          
          // 处理报表数据
          if (reportRes && reportRes.db && reportRes.db.length > 0) {
            // 计算总SKU、已采和未采数量
            let totalSKU = 0;
            let purchasedSKU = 0;
            
            reportRes.db.forEach(brand => {
              totalSKU += Number(brand.brand_total) || 0;
              purchasedSKU += Number(brand.user_total) || 0;
            });
            
            const unpurchasedSKU = totalSKU - purchasedSKU;
            
            // 更新我的报表描述信息
            this.quickActions[1].description = [
              `总SKU：${totalSKU}`,
              `已采：${purchasedSKU}`,
              `未采：${unpurchasedSKU}`
            ];
            this.repoLoding = false
          }
        }else{
          
        }

        
        
      } catch (error) {
        console.error('获取快捷功能失败:', error);
      }
    },    // 获取轮播图数据
    async getBanner() {
      try {
        // 轮播图
        let bannerRes = await this.$api.getHomeBanner({
          source: 1
        });
        if (bannerRes) {
          bannerRes.forEach(item => {
            item.img = item.adv_pic;
          });
          this.banner = bannerRes;
        }

        // 首页图片列表
        bannerRes = await this.$api.getHomeBanner({
          source: 10
        });
        this.homeImgList = bannerRes;
      } catch (error) {
        console.error('获取轮播图数据失败:', error);
      }
    },
    
    // 获取热门banner数据
    async getHotBanner() {
      try {
        let bannerRes = await this.$api.getHomeBanner({
          source: 6
        });
        if (bannerRes) {
          // 转换banner数据格式以匹配原有商品数据结构
          const formattedBanners = bannerRes.map(item => {
            let jumpMsg = JSON.parse(item.goods_id);
            return {
            id: item.id,
            image: item.adv_pic,
            url: item.url,
            goods_id: item.goods_id,
            data:jumpMsg.data
          }});

          this.hotProducts = formattedBanners;
        }
      } catch (error) {
        console.error('获取热门banner数据失败:', error);
      }
    },
    
    // 获取品牌列表
    async getBrandList() {
      try {
        // 品牌列表
        let brandRes = await this.$api.getDisList({
          type: 2
        });
        
        // 过滤品牌
        if (this.$store.state.exBrands) {
          brandRes = brandRes.filter(item => !this.$store.state.exBrands.includes(item.title));
        }
        
        // 为每个品牌分配颜色
        brandRes.forEach((item, index) => {
          item.color = this.brandColors[index % this.brandColors.length];
          
          // 处理品牌图片路径
          if (item.image) {
            // 如果是相对路径，转换为绝对路径
            if (item.image.startsWith('../')) {
              item.image = item.image.replace('../', '@/assets/');
            } else if (item.image.startsWith('./')) {
              item.image = item.image.replace('./', '@/assets/');
            }
          } else {
            // 如果没有图片，使用默认图片
            item.image = require('@/assets/newHome1/banner.png');
          }
        });
        
        // 处理品牌数据
        for (let item of brandRes) {
          try {
            if (item.s_image) {
              let simg = JSON.parse(item.s_image);
              item.cx = simg.cx;
              item.jp = simg.jp;
              item.xp = simg.xp;
            }
          } catch (error) {
            // 解析图片数据失败
          }
          
          // 获取品牌商品
          let res = await this.$api.getDisList({
            type: 2,
            id: item.id,
            page: 1,
            goods_commend: "11",
            limit: 6
          });
          
          if (res.db && res.db.length > 0) {
            res.db.forEach(goods => {
              goods.goods_price = this.$handlePrice(goods);
            });
            
            // 获取商品图片
            let listimgs = await this.$api.getGoodsListHomeImg({
              goods_id: res.db.map(item => item.goods_id).join(","),
              goods_type: "品牌首图",
              shop_id: 1780,
              store_id: 1780
            });
            
            listimgs.forEach(imgItem => {
              res.db.forEach(goods => {
                if (goods.goods_id == imgItem.goods_id) {
                  this.$set(goods, "homeImg", imgItem.url);
                }
              });
            });
            
            this.$set(this.homeBrandGoodsList, item.title, res.db);
          } else {
            this.homeBrandGoodsList[item.title] = [];
          }
        }
        console.log("brandRes",brandRes);
        
        this.homeBrandList = brandRes;
      } catch (error) {
        console.error('获取品牌列表失败:', error);
      }
    },
    
    // 获取推荐商品
    async getRecommendGoodsList() {
      try {
        let list = [];
        list = await this.$api.getlistRecom({
          goods_commend: 1,
          store_id: 1780,
        });
        
        if (list.length > 0) {
          // 过滤品牌
          if (this.$store.state.exBrands) {
            list = list.filter(item => !this.$store.state.exBrands.includes(item.oenaturebrand));
          }
          
          let ids = list.map(item => item.goods_id);
          let goods_id = ids.join(",");
          
          // 获取图片
          let listimgs = await this.$api.getGoodsListHomeImg({
            goods_id,
            goods_type: "WEB推荐",
            shop_id: 1780,
            store_id: 1780
          });
          
          listimgs.forEach(imgItem => {
            list.forEach(goods => {
              if (goods.goods_id == imgItem.goods_id) {
                this.$set(goods, "homeImg", imgItem.url);
                goods.goods_price = this.$handlePrice(goods);
              }
            });
          });
        }
        
        this.recommended = list;
      } catch (error) {
        console.error('获取推荐商品失败:', error);
      }
    },
    
    // 获取左侧轮播商品数据
    async getLeftCarouselItems() {
      try {
        // 这里可以根据实际需求获取特定的商品数据
        // 示例数据，实际应该从API获取
        this.leftCarouselItems = [
         
        ];
        
        // 实际应该从API获取数据，示例如下：
        /*
        let list = await this.$api.getSomeProducts(); // 替换为实际的API调用
        if (list && list.length > 0) {
          // 过滤品牌
          if (this.$store.state.exBrands) {
            list = list.filter(item => !this.$store.state.exBrands.includes(item.oenaturebrand));
          }
          
          let ids = list.map(item => item.goods_id);
          let goods_id = ids.join(",");
          
          // 获取图片
          let listimgs = await this.$api.getGoodsListHomeImg({
            goods_id,
            goods_type: "左侧轮播",
            shop_id: 1780,
            store_id: 1780
          });
          
          listimgs.forEach(imgItem => {
            list.forEach(goods => {
              if (goods.goods_id == imgItem.goods_id) {
                this.$set(goods, "homeImg", imgItem.url);
                goods.goods_price = this.$handlePrice(goods);
              }
            });
          });
          
          this.leftCarouselItems = list;
        }
        */
      } catch (error) {
        console.error('获取左侧轮播商品失败:', error);
      }
    },
    
    // 获取秒杀商品列表
    async getSeckillList() {
      try {
        let chain = "";
        if (this.$store.state.for_branch) {
          chain = 3;
        } else {
          chain = 1;
        }
        
        let seckiList = await this.$api.getSeckiList({
          mark: 1,
          chain,
          shop: this.$store.state.for_branch || this.$store.state.shop
        });
        
        let arr = await this.$api.getSeckiList({
          mark: 2,
          chain,
          shop: this.$store.state.for_branch || this.$store.state.shop,
        });
        
        seckiList.forEach(item => {
          // 丹阳仓
          if (this.$store.state.is_sh == 0) {
            item.goods_storage = item.goods_stcids || 0;
          }
        });
        
        let goodsWithPositiveStorage = seckiList.filter(item => item.goods_storage > 0);
        let goodsWithZeroOrNegativeStorage = seckiList.filter(item => item.goods_storage <= 0);
        
        // 将两部分数组连接起来，形成新的数组
        seckiList = goodsWithPositiveStorage.concat(goodsWithZeroOrNegativeStorage);
        
        this.seckiList = [
          ...seckiList,
          ...arr,
        ];
        
        this.handlerDay();
      } catch (error) {
        console.error('获取秒杀商品失败:', error);
      }
    },
    
    // 选择标签
    async selectTag(oesort) {
      this.selectedTag = oesort;
      await this.getHotProducts(oesort);
    },
    
    // 获取热门商品数据
    async getHotProducts(oesort = '') {
      try {
        // 获取热门商品数据
        let params = {
          goods_commend: 4,
          store_id: 1780,
        };
        
        // 如果有选中的分类，则添加oesort参数
        if (oesort) {
          params.oesort = oesort;
        }
        
        let res = await this.$api.getlistRecom(params);
        
        if (res && res.length > 0) {
          // 过滤品牌
          if (this.$store.state.exBrands) {
            res = res.filter(item => !this.$store.state.exBrands.includes(item.oenaturebrand));
          }
          
          // 获取商品图片
          let ids = res.map(item => item.goods_id);
          let goods_id = ids.join(",");
          
          let listimgs = await this.$api.getGoodsListHomeImg({
            goods_id,
            goods_type: "热门商品",
            shop_id: 1780,
            store_id: 1780
          });
          
          // 合并商品数据和图片
          res.forEach(item => {
            let img = listimgs.find(img => img.goods_id == item.goods_id);
            // if (img) {
            //   item.image = img.url;
            // } else {
            // }
            item.image = require('@/assets/newHome1/热门商品.png');
            item.price = this.$handlePrice(item);
          });
          
          this.hotProducts = res.slice(0, 4); // 只取前4个商品
        } else {
          this.hotProducts = [];
        }
      } catch (error) {
        console.error('获取热门商品失败:', error);
      }
    },
    
    // 处理倒计时
    handlerDay() {
      let arrs = ["seckiList"];
      let key = "";
      let dayTime = 60 * 60 * 24 * 1000;
      
      arrs.forEach(arr => {
        if (arr == 'prefoList') {
          key = "start_time";
        } else {
          key = "end_time";
        }
        
        try {
          this[arr].forEach(acti => {
            let leftTime = 0;
            if (arr == 'prefoList') {
              acti[key] = acti[key] * 1000;
              leftTime = acti[key] - new Date();
              acti.isNow = false;
            } else {
              acti.isNow = true;
              if (arr == 'seckiList') {
                // 秒杀未开始/开始在同一数组 用状态判断
                if (acti.state == 40) {
                  key = "start_time";
                }
              }
              if (key == 'start_time') {
                leftTime = acti[key] * 1000 - new Date();
              } else {
                leftTime = acti[key] - new Date();
              }
            }
            
            if (leftTime > dayTime) {
              let leftDay = parseInt(leftTime / dayTime);
              this.$set(acti, "leftDay", leftDay);
              // 剩余总时间减去大于一天的天数
              this.$set(acti, "leftTime", acti[key] - leftDay * dayTime);
            } else {
              this.$set(acti, "leftTime", acti[key]);
            }
            
            if (arr == 'nowList' || arr == 'overList') {
              let rote = "";
              if (Number(acti.totalsum) > 0) {
                rote = this.$hnwTools.div(acti.totalsum_now, acti.totalsum) * 100;
              } else {
                rote = 0;
              }
              this.$set(acti, "rote", Number(rote.toFixed(2)));
            }
            
            // 标记
            if (arr == "overList") {
              this.$set(acti, "notbuy", 'over');
            } else if (arr == 'prefoList') {
              this.$set(acti, "notbuy", 'pre');
            }
          });
        } catch (e) {
          // 错误处理
        }
      });
    },
    
    // 跳转到指定位置
    toView(title) {
      document.getElementById(title).scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    
    // 搜索商品
    findGoods(key, text) {
      let clearKey = "";
      if (key == "searchOesort") {
        clearKey = "searchText";
      } else {
        clearKey = "searchOesort";
      }
      
      this.$store.commit('UpDateState', {
        [clearKey]: "",
        [key]: text
      });
      
      this.toPath("/find/index");
    },
    
    // 页面跳转
    toPath(path) {
      if(this.$store.state.store_id==1780){
        if(path.includes('inveStatis')&&!this.$store.state.storePath.includes("inveStatis")){
          return this.$warMsg("暂无权限");
        }
        if(path.includes('newSaleAnalysis')&&!this.$store.state.storePath.includes("newSaleAnalysis")){
          return this.$warMsg("暂无权限");
        }
        
      }else{

        if(path.includes("reportCenter")&&this.$store.state.storePath&&this.$store.state.storePath.includes("reportCenter")){
          return this.$warMsg("暂无权限");
        }
      }
      this.$router.push(path);
    },
    
    // 搜索品牌
    comSearchBrand(brand) {
      localStorage.setItem("epc-brand-text", brand);
      this.toPath("/brand");
    },
    
    // 跳转到商品详情
    toGoodsInfo(acti) {
      acti.preRou = "首页";
      if (acti.g_id) {
        acti.goods_id = acti.g_id;
      }
      let rou = '/index/goodsinfo';
      localStorage.setItem("hnw-web-item-data", JSON.stringify(acti));
      this.toPath(rou);
    },
    
   
    
    // 轮播图跳转
    async bannerJump(banner) {
      console.log("banner",banner);
      
      if (banner.url) {
        let acti = this.nowCollectList.find(col => col.setlist_id == 140);
        if (acti) {
          this.toGoodsInfo(acti);
        } else {
          this.$warMsg("暂无信息");
        }
        // 如果图片能跳转商品
      } else if (banner.goods_id) {
        // 获取过滤品牌列表
        const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : [];
        
        // 检查是否需要过滤
        if (exBrands.length > 0) {
          // 检查goods_id是否直接包含过滤品牌
          let shouldFilter = false;
          for (let brand of exBrands) {
            if (banner.goods_id.includes(brand)) {
              shouldFilter = true;
              break;
            }
          }
          
          if (shouldFilter) {
            return; // 过滤掉，不执行跳转
          }
        }

        try {
          let jumpMsg = JSON.parse(banner.goods_id);
          if (jumpMsg.type == 'goods') {
            const res = await this.$api.getGoodsInfo({
              goods_id: jumpMsg.data
            });
            
            // 检查配件数据中的oenaturebrand是否在过滤品牌中
            if (exBrands.length > 0 && res && res.oenaturebrand) {
              if (exBrands.includes(res.oenaturebrand)) {
                return; // 过滤掉，不执行跳转
              }
            }
            
            this.toGoodsInfo(res);
          } else if (jumpMsg.type == 'brand') {
            // 检查品牌是否在过滤列表中
            if (exBrands.length > 0 && exBrands.includes(jumpMsg.data)) {
              return; // 过滤掉，不执行跳转
            }

            this.$store.commit('UpDateState', {
              searchText: jumpMsg.data
            });

            this.toPath('/find/index');
          } else if (jumpMsg.type == 'link') {
            this.toPath(jumpMsg.data);
          } else if (jumpMsg.type == 'bodyImg') {
            localStorage.setItem("web-banner-body-img", jumpMsg.data);
            this.toPath("/bodyImg");
          } else if (jumpMsg.type == 'adcerImg') {
            let tempArr = jumpMsg.data.split("&");
            if (tempArr[1] && tempArr[1] != 'undefined') {
              localStorage.setItem("web-banner-body-img", jumpMsg.data.split("&")[1]);
              this.toPath("/bodyImg");
            } else if (tempArr[2]) {
              // 检查搜索内容是否在过滤品牌中
              if (exBrands.length > 0 && exBrands.includes(tempArr[2])) {
                return; // 过滤掉，不执行跳转
              }
              
              this.$store.commit('UpDateState', {
                searchText: tempArr[2]
              });
              this.toPath('/find/index');
            }
          }
        } catch (error) {
          // 错误处理
        }
      } else if (banner.img.search('vin') != -1) {
        if (!this.token) {
          this.$warMsg("未登录账号");
          return this.toPath("/login");
        } else if (this.$isCompany()) {
          let link = location.href.split("#")[0];
          window.open(link + '#/epc/home/vin');
        }
      }
    },
    
    // 加入购物车
    async joinCart(carItem) {
      if (this.$isCompany()) {
        if (carItem.goods_storage < 1) {
          return this.$store.commit('UpDateState', { invDia: true });
        }
        
        let carMessage = {
          goods_id: carItem.goods_id,
          sccode: carItem.sccode,
          oecode: carItem.oecode,
          goods_name: carItem.goods_name,
          goods_price: carItem.goods_price,
          goods_storage: carItem.goods_storage,
          goods_num: 1,
          store_id: carItem.store_id,
          store_name: carItem.store_name,
          cart_type: '1',
        };
        
        let res = await this.$api.joinCart([carMessage]);
        // 跳转到加入成功页
      }
    },
    
    // 处理滚动事件
    handleScroll() {
      // 获取当前的滚动距离
      this.scrollDistance = document.documentElement.scrollTop;
      if (this.scrollDistance > 650) {
        this.navObj.left = this.navLeft + "px";
      } else {
        try {
          const fixedElement = document.getElementById('home-content');
          const rect = fixedElement.getBoundingClientRect();
          const leftDistanceToDocument = rect.left + window.pageXOffset;
          this.navLeft = leftDistanceToDocument - 140;
          this.navObj = {};
        } catch (error) {
          // 错误处理
        }
      }
    },
    
    // 处理窗口大小变化
    handleResize() {
      try {
        const fixedElement = document.getElementById('home-content');
        const rect = fixedElement.getBoundingClientRect();
        const leftDistanceToDocument = rect.left + window.pageXOffset;
        this.navLeft = leftDistanceToDocument - 140;
      } catch (error) {
        // 错误处理
      }
    },
    
    // 跳转到秒杀商品
    goRecommend(acti) {
      if (acti.state == 20) {
        if (acti.goods_storage > 0) {
          acti.preRou = "首页";
          let rou = '/index/goodsinfo';
          localStorage.setItem("hnw-web-item-data", JSON.stringify(acti));
          this.$router.push(rou);
        } else {
          this.$warMsg("商品已抢光");
        }
      } else {
        this.$warMsg("秒杀未开始");
      }
    },
    
    // 跳转到常用功能页面
    goToFunction(path) {
      if (path) {
        this.$router.push(path);
      }
    },
    
    // 处理快捷功能点击事件
    handleQuickActionClick(action) {
      switch(action.title) {
        case '新产品':
          this.$router.push('/hnwZone/index?from=newProduct');
          break;
        case '我的报表':
          if(this.$store.state.store_id==1780){
            if(!this.$store.state.storePath.includes("inveStatis")&&!this.$store.state.storePath.includes("newSaleAnalysis")){
              return this.$warMsg("暂无权限");
            }else{
              this.toPath('/reportCenter/index/1');
            }
          }else{
            // 1
            if(this.$store.state.storePath&&this.$store.state.storePath.includes("reportCenter")){
              return this.$warMsg("暂无权限");
            }else{
              this.toPath('/reportCenter/index/1');
            }
          }
          break;
        case '最近资讯':
          // 可以根据需要添加相应的跳转逻辑
          // this.$router.push('/news/list');
          this.$router.push('/news/info/'+action.newsId);
          console.log('最近资讯被点击');
          break;
        case '今日到货':
          // 可以根据需要添加相应的跳转逻辑
          // this.$router.push('/news/list');
          this.toPath('/index/arrived');
          console.log('今日到货被点击');
          break;
        case '奔宝专区':
          // 可以根据需要添加相应的跳转逻辑
          // this.$router.push('/news/list');
          this.toPath('/index/benzm');
          console.log('奔宝专区');
          break;
        default:
          // 其他情况可以保持原来的逻辑或者添加新的处理
          console.log('未知的快捷功能被点击');
      }
    },
    
    // 导航到分类
    navigateToCategory(item) {
      if (item.name === '品牌馆') {
        this.$router.push('/brand');
      } else {
        // 设置搜索条件并跳转到搜索页面
        this.$store.commit('UpDateState', {
          searchOesort: item.name
        });
        this.$router.push('/find/index');
      }
    }
  },
  mounted() {
    // 添加滚动事件监听器
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    
    // 初始化数据
  },
  created() {
    this.initData();
    // 获取本地存储数据
    // this.getLocalStorageData();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss" scoped>

$secondary-color: #e60000;
$background-light: #f5f5f5;
$text-color: #333;
$text-muted: #666;
$border-color: #eee;

.main-content {
  padding: 20px 0;
  background-color: $background-light;

  // 通用标题样式
  .section-title {
    font-size: 22px;
    font-weight: bold;
    color: $text-color;
    margin: 0 0 20px 0;
  }

  // 轮播图样式
  #home-banner{
		position: relative;
		height: 450px;
    margin-bottom: 30px;
		.bannder{
			// height: 450px;
			// width: 100%;
			// position: absolute;
			width: 1920px;
			height: 450px;
			padding: 0;
			position: absolute;
			z-index: 1;
			margin: 0 auto;
			overflow: hidden;
			left: calc(50% - 960px);
			img{
				height: 450px;
				width: 100%;
				max-width: 1920px;
				cursor: pointer;
				margin: 0 auto;
				object-fit: cover;
			}
			//  修改指示器样式
			
			::v-deep .el-carousel__indicators{
				
				// background: rgba($color: #fff, $alpha: 0.4);
				padding: 0 2px;
				height: 18px;
				display: flex;
				align-items: center;
				border-radius: 9px;
				bottom: 20px;
				.el-carousel__indicator{
					padding: 0 6px;
					.el-carousel__button{
						width: 12px;
						height: 12px;
						border-radius: 50%;
					}
				}
				.is-active{
					.el-carousel__button{
						background: #fff;
						cursor: pointer;
						transform: scale(1.2);
					}
				}
			}
		}
		.banner-content{
			position: relative;
			height: 100%;
			display: flex;
			justify-content: space-between;
			.goods-classify{
				z-index: 99;
				width: 286px;
				// background: #343435;
				color: #fff;
				position: relative;
        // top: -49px;
				::v-deep .el-collapse{
          // background: #343435;
					border: none;
					.el-collapse-item{
            border-radius: 8px;
						.el-collapse-item__header{
							border: none;
							height: auto;
							line-height: 1;
							background: #062D79;
              border-radius: 10px 10px 0px 0px;
							color: #fff;
							.el-collapse-item__arrow {
								color: #fff;
							}
						}
						.el-collapse-item__wrap{
							border: none;
						}
					}
					.el-collapse-item__content{
						padding-bottom: 0;
						// background: #343435;
					}
				}
				.classifys-head{
					display: flex;
					align-items: center;
					padding: 10px 20px;
					background: #062D79;
					width: 100%;
          font-size: 16px;
					box-sizing: border-box;
          border-radius: 10px 10px 0px 0px;
					img{
						margin-right: 20px;
						width: 28px;
					}
				}
				.classifys-list{
					
					height: 400px;
					// height: 440px;
					padding: 20px 0;
					display: flex;
					box-sizing: border-box;
					flex-direction: column;
					.classifys-item{
						// height: 25%;
						box-sizing: border-box;
						padding:0 20px;
						flex: 1;
						cursor: pointer;
						.classifys-title{
							display: flex;
							justify-content: space-between;
							align-items: center;
							padding: 10px 0;
							
							.title-left{
								display: flex;
								align-items: center;
								color: #000;
								img{
									margin-right: 20px;
									width: 24px;
								}
							}
							.title-r{
								img{
									
									width: 14px;
								}
								.more{
									// width: 7px;
									
								}
							}
						}
						.goods-name{
							padding-left: 45px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: normal; /* Ensure normal white-space handling */
							.name{
								margin-right: 10px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								font-size: 14px;
								color: #999999;
								line-height: 24px;
							}

						}
						.more-names{
							width: 914px;
							height: 450px;
							overflow-y: auto;
							overflow-x: hidden;
							background: #fff;
							position: absolute;
							top: 0;
							right: -914px;
							padding: 35px 30px;
							box-sizing: border-box;
							border: 1px solid #F2F2F2;
							.name{
								margin-right: 10px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								font-size: 14px;
								color: #999999;
								line-height: 24px;
							}
							.name:hover{
								color: #2260BB;
							}
						}
					}
					.classifys-item:hover{
						color: #333;
						background: #fff;
						border-right: 1px solid #F2F2F2;
						.title-left{
							color: #333;
						}
					}
				}
			}
			.user-info{
				z-index: 20;
				width: 268px;
				margin-top: 10px;
				// height: 430px;
				height: auto;
				// padding: 25px 10px;
				box-sizing: border-box;
				text-align: center;
				overflow: hidden;
				max-height: 430px;
        border-radius: 8px;
				.user-head{
					padding: 0 10px;
					padding-top: 25px;
					background: #fff;
					.logo-face{
						width: 54px;
						cursor: pointer;
					}
					.huanying{
						font-family: Source Han Sans CN;
						font-weight: 400;
						font-size: 16px;
						color: #063376;
						line-height: 24px;
						cursor: pointer;
						i{
							margin-left: 5px;
						}
					}
					.store-name{
						font-family: Source Han Sans CN;
						font-weight: 400;
						font-size: 12px;
						color: #999999;
						line-height: 24px;
						padding: 5px 0;
					}
					.user-btn{
						padding: 20px 0;
						display: flex;
						justify-content:space-around;
						.el-button{
							width: 90px;
						}
						.lo-gin{
							background: #063376;
							border: 1px solid#063376;
							color: #fff;
						}
					}
				}
				.menu-box{
					height: 275px;
					padding: 0 10px;
					padding-bottom: 25px;
					transition: all 0.5s;
					// padding: 25px 10px;
					background: #fff;
					.menu-list{
						border-top: 1px solid #ddd;
						display: flex;
            justify-content: space-between;
						flex-wrap: wrap;
						.menu-item{
							cursor: pointer;
							width: 64px;
							text-align: center;
							margin-top: 10px;
              padding: 20px 0 5px;
              background: #F2F4FA;
							.menu-title{
								font-family: Source Han Sans CN;
								font-weight: 400;
								font-size: 12px;
								color: #666666;
								line-height: 24px;
							}
						}
					}
				}
			}
			.hide-user-info{
				margin-top: 0px;
				.user-head{

					height: 58px;
					padding: 0 20px;
					display: flex;
					justify-content: center;
					align-items: center;
					img{
						margin-right: 5px;
					}
					.store-name{
						display: none;
					}
				}
			}
		}
	}

  // 快捷功能样式
  .quick-actions {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    
    flex-wrap: wrap;

    .action-item {
      flex: 1;
      cursor: pointer;
      min-width: 250px;
      height: 146px;
      
      // height: 110px;
      box-sizing: border-box;
      padding: 18px 20px;
      // padding: 10px 5px;
      border-radius: 8px; 
      transition: transform 0.3s ease;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      .back-img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        // object-fit: cover;
        // /* 新增这一行，调整图片位置 */
        // object-position: right center; /* 或者尝试 80% center; */
        // border-radius: 8px;
      }
      &:hover {
        transform: translateY(-5px);
      }

      .icon {
        // font-size: 36px;
        width: 120px;
        // width: 90px;
        margin-bottom: 15px;
      }

      .text {
        flex: 1;
        z-index: 2;
        height: 100%;
        .title{
          color: #062D79;
          border-bottom: 1px solid #E7E7E7;
          // padding-bottom: 8px;
          padding-bottom: 4px;
          position: relative;
          .title-icon{
            position: absolute;
            top: -4px;
            right: 0;
            display: flex;
            align-items: center;
            width: 18px;
          }

          .title-date{
            font-size: 12px;
            
          }
        }
        .text-content {
          padding-top: 10px;
          // padding-top: 5px;
          .dh-sku{
            position: absolute;
            top: 51px;
            left: 115px;
            font-size: 12px;
            color: #fff;
            display: flex;
            align-items: center;
            width: 100px;
            justify-content: space-between;
            .num{
              font-size: 15px;
              color: #f00;
              font-weight: bold;  
            }
          }
        }
        p {
          margin: 0;
          line-height: 1.5;
        }
        .sku {
          // color: #00552A;
          margin-bottom: 10px;
          color: #666666;
          .dot{
            width: 6px;
            height: 6px;
            background-color: #062D79;
            border-radius: 50%;
            display: inline-block;
            position: relative;
            margin-right: 12px;
          }
                    
          .dot::before {
            content: '';
            position: absolute;
            top: -4px;
            left: -4px;
            right: -4px;
            bottom: -4px;
            border: 1px solid #062D79;
            border-radius: 50%;
          }
        }
        .hnw-btns{
          .hnw-btn{
            margin-bottom: 10px;
            img{
              height: 28px;
              
            }
          }
        }
        .tags {
          display: flex;
          gap: 8px;
          
          flex-wrap: wrap;

          .tag {
            // background-color: rgba(255, 255, 255, 0.3);
            // color: white;
            border: 1px solid #000;
            
            // padding: 4px 8px;
            padding: 2px 4px;
            width: 30%;
            margin: 3px 0;
            // margin: 5px 0;
            box-sizing: border-box;
            text-align: center;
            border-radius: 12px;
            font-size: 12px;
          }
        }
      }
    }
  }

  

  // 热门商品样式
  .hot-products {
    background-color: white;
    // padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-section {
      // width: 112px;
      width: 240px;
      height: 340px;
      background-image: url('~@/assets/newHome1/热门商品.png');
      background-size: 240px 340px;
      background-repeat: no-repeat;
      background-position: center;
      h3 {
        color: $text-color;
        margin: 0;
        font-size: 32px;
        font-weight: bold;
      }

      .category-tags {
       
       
        margin-top: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .tag {
          background-color: rgba(255, 255, 255, 0.3);
          color: #fff;
          padding: 0 8px;
          width: 124px;
          // width: 90px;
          // 
          height: 30px;
          line-height: 30px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          box-sizing: border-box;
          margin-bottom: 20px;
          border-radius: 12px;
          font-size: 12px;
          cursor: pointer;
          
          // display: flex;
          // align-items: center;
          // justify-content: center;
          &:hover {
            background-color: #fff;
            color: #002976;
          }
        }
        .active {
          background-color: #fff;
          color: #002976;
        }
      }
    }

    .products-grid {
      flex: 1;
      padding: 0 10px;
      .product-card {
        // border: 1px solid $border-color;
        border-radius: 8px;
        overflow: hidden;
        transition: transform 0.3s ease;
        cursor: pointer;
        .product-image {
          width: 100%;
          height: 340px;
          object-fit: cover;
          background-color: #f5f5f5;
          border-radius: 8px;
          display: block;
        }
        .product-name {
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          line-height: 24px;
        }

        .product-oem {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 24px;
        }

        .price-brand-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 204px;
          height: 30px;
          padding: 10px 15px;
          box-sizing: border-box;
          border-top: 1px solid #eee;
          background: url('~@/assets/newHome1/价格.png') no-repeat center center;
          background-size: 204px 30px;
          .price {
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 30px;
          }
          .brand {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 30px;
          }
        }      
      }
    }
  }

  // 品牌区域样式
  .brand-section {
    background-color: #f5f5f5;
    // padding:20px 0;
    // padding-top: 20px;
    border-radius: 8px;
    // margin-bottom: 20px;
    

    

    .brands-grid {
      
      .brand-column {
        // border: 1px solid $border-color;
        // border-radius: 8px;
        overflow: hidden;
        margin-bottom: 20px;
        .brand-card{
          
          background: #fff;
        }
        .brand-header {
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          img {
            max-height: 100%;
            max-width: 100%;
          }
        }

        .brand-products {
          padding: 15px;
          
          .top-three-products {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 15px;
            // margin-bottom: 15px;
            .brand-product{
              // padding-bottom: 30px;
            }
          }
          
          .bottom-two-products {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
            border-top: 1px solid $border-color;
            >.brand-product{
            }
          }

          .brand-product {
            // border: 1px solid $border-color;
            // border-radius: 8px;
            padding: 10px 0 30px;
            border-right: 1px solid #eee;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            text-align: center;

            img {
              width: 80px;
              height: 80px;
              object-fit: contain;
              margin-bottom: 10px;
            }

            .product-details {
              text-align: center;

              p {
                margin: 0;
                font-size: 14px;
              }

              .oe {
                color: $text-muted;
                font-size: 12px;
                margin: 5px 0;
              }

              .price {
                color: $secondary-color;
                font-weight: bold;
                margin-top: 5px;
              }
            }
          }

          // 新增的水平布局样式
          .brand-product.horizontal-layout {
            flex-direction: row;
            align-items: center;
            text-align: left;
            
            .product-image-left {
              width: 60px;
              height: 60px;
              object-fit: contain;
              margin-right: 10px;
              margin-bottom: 0;
            }
            
            .product-details-horizontal {
              flex: 1;
              
              p {
                margin: 0;
                font-size: 14px;
                text-align: left;
              }
              
              .oe {
                color: $text-muted;
                font-size: 12px;
                margin: 5px 0;
              }
              
              .price {
                color: $secondary-color;
                font-weight: bold;
                margin-top: 5px;
              }
            }
          }
        }
      }
    }
  }

  // 常用功能样式
  .common-functions {
    background-color: white;
    padding: 20px 10px;
    border-radius: 8px;
    margin-bottom: 20px;
    

   
    .functions-grid{
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .feature-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      background: white;
      
      gap: 24px;
      width: 372px;
      box-sizing: border-box;
      max-width: 500px;
      margin: 0 auto 20px;
      
      .icon-img {
        width: 100%;
        // height: 80px;
        object-fit: contain;
        flex-shrink: 0; /* 防止图片被压缩 */
      }
    
    }
  }

  // 推荐区域样式
  .recommended-section {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    background: url('~@/assets/newHome1/beijing.png') no-repeat center center;
    background-size: 100% 100%;
    

    .recommended-grid {
      display: flex;
      gap: 20px;
      
      // 新增的左侧商品轮播样式
      .left-product-carousel {
        flex-shrink: 0;
        width: 276px;
        height: 294px;
        background: url('~@/assets/newHome1/chengse.png') no-repeat center;
        background-size: 100% 100%;
        .left-custom-swiper{
          width: 100%;
          height: 100%;
        }
        /* 自定义分页器样式 */
        :deep(.swiper-pagination-bullet) {
          width: 10px;
          height: 10px;
          background-color: #ccc;
          opacity: 1;
          margin: 0 4px;
          border-radius: 50%;
        }

        :deep(.swiper-pagination-bullet-active) {
          background-color: #F18C54;
          border-color: #F18C54;
        }
          
        .left-product-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          // padding: 20px;
          box-sizing: border-box;
          // height: 100%;
          .left-product-item{
            width: 220px;
            background: #FFFFFF;
            box-shadow: 0px 1px 16px 0px rgba(172,120,87,0.1);
            border-radius: 10px;
            text-align: center;
          }
          .left-product-info {
            text-align: center;
            margin-top: 5px;
            
            .title {
              font-size: 16px;
              font-weight: bold;
              margin: 5px 0;
              color: #333;
            }
            
            .oe {
              font-size: 12px;
              color: #999;
              margin: 5px 0;
            }
            
            .price {
              font-size: 18px;
              color: #e60000;
              font-weight: bold;
              margin: 10px 0;
            }
          }
        }
      }
      
      // 右侧推荐网格样式
      .right-recommend-grid {
        flex: 1;
        
        .goods-card{
          margin: 0;
          box-sizing: border-box;
          overflow: hidden;
          border-right: 1px solid #eee;
          .card-fot{
            >div{
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 14px;
            }
            .goods-msg{
              color: #999;
              margin: 5px 0;
            }
            .goods-name{
              font-size: 16px;
              color: #666;
              margin-top: 5px;
            }
          }
          .join-cart-box{
            text-align: right;;
            padding-right: 10px;
            
            img{
              width: 24px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  
}
</style>
